import { DirectionProvider as DirectionProviderPrimitive } from "@radix-ui/react-direction"

import type { ReactNode } from "react"

import { useLocale } from "@/hooks/use-locale"

export function DirectionProvider({
  children,
}: {
  children: ReactNode
}) {
  const { direction } = useLocale()

  return (
    <DirectionProviderPrimitive dir={direction}>
      {children}
    </DirectionProviderPrimitive>
  )
}
